import { SparklesIcon } from '@heroicons/react/16/solid'

import { useUserContext } from 'context'
import { useTranslation } from 'react-i18next'
import { Heading } from '../../../components/ui/Heading'
import { useDiscover } from '../hooks/useDiscover'
import BackButton from './assistant/BackButton'

export default function AssistantHeader() {
  const { t } = useTranslation()
  const {
    hideAssistant,
    assistantDetail,
    setAssistantDetail,
    shouldClickOnMandatoryDimension,
    setShouldClickOnMandatoryDimension,
    setShouldShowCompletionOnboardingModal,
    showAssistantBackButton,
    setShowAssistantBackButton
  } = useDiscover()

  const { activeSpace } = useUserContext()

  const hasCompletedOnboarding = activeSpace?.hasCompletedOnboarding

  return (
    <div className='flex h-20 flex-row items-center justify-between border-b border-lightGrey px-4 sm:px-6'>
      {hasCompletedOnboarding &&
        (assistantDetail || showAssistantBackButton) && (
          <BackButton
            onClick={() => {
              setAssistantDetail(false)
              const localOnboardingCompleted =
                localStorage.getItem('showed_completion_onboarding_modal') ===
                'true'
              if (
                shouldClickOnMandatoryDimension === true &&
                localOnboardingCompleted === false
              ) {
                setTimeout(() => {
                  setShouldClickOnMandatoryDimension(false)
                  setShouldShowCompletionOnboardingModal(true)
                  localStorage.setItem(
                    'showed_completion_onboarding_modal',
                    'true'
                  )
                }, 1500)
              }
              hideAssistant()
              setShowAssistantBackButton(false)
            }}
          />
        )}
      <div className='flex flex-row items-center text-base font-semibold text-gray-900'>
        <SparklesIcon className='mr-4 size-4 text-aivyBlue' />
        <Heading level={3}>{t('discover.assistant.title')}</Heading>
      </div>
      {/* <div className='ml-3 flex h-7 items-center'>
        <button
          type='button'
          onClick={() => hideAssistant()}
          className='focus-visible:outline-hidden relative rounded-md bg-white text-rockGrey hover:text-gray-500 focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2'
        >
          <span className='absolute -inset-2.5' />
          <span className='sr-only'>Close panel</span>
          <XMarkIcon aria-hidden='true' className='size-6' />
        </button>
      </div> */}
    </div>
  )
}
